'use strict';
const _ = require('underscore');
module.exports = function FixedPoint(initialValue, initialDecimals) {
	const self = this,
		isInstance = function (value) {
			return FixedPoint.prototype.isPrototypeOf(value);
		},
		extractNumber = function () {
			let value;
			if (_.isNumber(initialValue)) {
				value = initialValue;
			} else if (_.isString(initialValue)) {
				value = parseFloat(initialValue);
			}
			if (_.isNaN(value) || !_.isNumber(value)) {
				throw new Error('not a number ' + initialValue);
			}
			return value;
		},
		extractDecimals = function () {
			const source = String(initialValue),
				dotPosition = source.indexOf('.');
			if (initialDecimals !== undefined) {
				if (!_.isNumber(initialDecimals) || initialDecimals < 0) {
					throw new Error('invalid decimals ' + initialDecimals);
				}
				return initialDecimals;
			}
			if (dotPosition < 0) {
				return 0;
			}
			return source.length - dotPosition - 1;
		};
	let numericValue,
		numberOfDecimals;
	if (isInstance(initialValue)) {
		numericValue = initialValue.value();
		numberOfDecimals = initialValue.decimals();
	} else if (initialValue !== undefined) {
		numericValue = extractNumber();
		numberOfDecimals = extractDecimals();
	} else {
		numericValue = 0;
		numberOfDecimals = 0;
	}
	self.toString = function () {
		return numericValue.toFixed(numberOfDecimals);
	};
	self.value = function () {
		return numericValue;
	};
	self.decimals = function () {
		return numberOfDecimals;
	};
	self.add = function (value) {
		const adder = new FixedPoint(value);
		return new FixedPoint(numericValue + adder.value(), Math.max(numberOfDecimals, adder.decimals()));
	};
};
